// Unit conversion helpers between metric (stored) and imperial (display).

export function kgToLbs(kg) {
  return Math.round(parseFloat(kg) * 2.20462 * 10) / 10;
}

export function lbsToKg(lbs) {
  return Math.round(parseFloat(lbs) / 2.20462 * 10) / 10;
}

export function cmToFtIn(cm) {
  const totalIn = parseFloat(cm) / 2.54;
  const ft = Math.floor(totalIn / 12);
  const inches = Math.round(totalIn - ft * 12);
  if (inches === 12) return { ft: ft + 1, in: 0 };
  return { ft, in: inches };
}

export function ftInToCm(ft, inches) {
  const totalIn = parseFloat(ft || 0) * 12 + parseFloat(inches || 0);
  return Math.round(totalIn * 2.54 * 10) / 10;
}

export function displayWeight(kg, units) {
  if (units === "imperial") return `${kgToLbs(kg)} lb`;
  return `${kg} kg`;
}

export function displayHeight(cm, units) {
  if (units === "imperial") {
    const { ft, in: inches } = cmToFtIn(cm);
    return `${ft}'${inches}"`;
  }
  return `${cm} cm`;
}
